import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

interface IJourneyList {
  id: string;
  name: string;
}

interface IStorySelectList {
  id: string;
  name: string;
  cover: any;
  preview: string;
}

interface IInitialState {
  openDialog: boolean;
  journeyData: IJourneyList[];
  journeyId: string;
  journeyName: string;
  importJourneyId: string;
  storySelectList: IStorySelectList[];
  shareLink: string;
}

const initialState: IInitialState = {
  openDialog: false,
  journeyData: [],
  journeyId: "",
  journeyName: "",
  importJourneyId: "",
  storySelectList: [],
  shareLink: "",
};

const slice = createSlice({
  name: "storybookCollaboration",
  initialState,
  reducers: {
    setJourneyData(state, action) {
      state.journeyData = action.payload;
    },
    setJourneyName(state, action) {
      state.journeyName = action.payload;
    },
    setOpenDialog(state, action) {
      state.openDialog = action.payload;
    },
    setImportJourneyId(state, action) {
      state.importJourneyId = action.payload;
    },
    setStoryList(state, action) {
      state.storySelectList = action.payload;
    },
    setShareLink(state, action) {
      state.shareLink = action.payload;
    },
  },
});

const BASE_URL = process.env.REACT_APP_API_URL;

export const importJourney = () => async (dispatch) => {
  try {
    const response = await axios.get(`${BASE_URL}/events/api/v1/journey?meta=true`);
    if (response?.status === 200) {
      if (response?.data?.data) {
        dispatch(slice.actions.setJourneyData(response.data.data));
        dispatch(slice.actions.setJourneyName(response?.data?.data[0]?.name || ""));
        dispatch(fetchAllStory(response?.data?.data[0]?.id, "story"));
      }
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const importDeckJourney = () => async (dispatch) => {
  try {
    const response = await axios.get(`${BASE_URL}/events/api/v1/journey?meta=true&type=deck`);
    if (response?.status === 200) {
      if (response?.data?.data) {
        dispatch(slice.actions.setJourneyData(response.data.data));
        dispatch(slice.actions.setJourneyName(response.data.data[0].name));
        dispatch(fetchAllDeck(response.data.data[0].id));
      }
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchAllStory = (journeyId: string, type: string) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/events/api/v1/journey/${journeyId}/story?meta=true&type=${type.toLowerCase()}`
    );
    if (response?.status === 200) {
      if (response?.data?.data) {
        dispatch(slice.actions.setStoryList(response?.data?.data));
      }
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchAllDeck = (journeyId: string) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/events/api/v1/journey/${journeyId}/story?type=deck`
    );
    if (response?.status === 200) {
      if (response?.data?.data) {
        dispatch(slice.actions.setStoryList(response?.data?.data));
      }
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const reducer = slice.reducer;
export const storyBookCollaboration = slice.actions;
export default slice;
